import React, { Component } from "react";
import PropTypes from "prop-types";
import Error from "form/components/error";

const errorBoundary = WrappedComponent => class ErrorBoundary extends Component {
  static propTypes = {
    locale: PropTypes.string,
    size: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    console.error("error: ", error);
    console.error("info error: ", info);
    this.setState({ hasError: true });
  }

  render() {
    const { size, locale } = this.props;
    const { hasError } = this.state;

    if (hasError === true) {
      return [
        <Error locale={locale} size={size} />
      ];
    }

    return (<WrappedComponent {...this.props} />);
  }
}

export default errorBoundary;